import {StyleteqState} from "../_definitions/styleteq";


export const myShopsSelector = (state: StyleteqState) => state.myShops;

// shop profile selectors
export const shopProfileActiveModalSelector = (state: StyleteqState) => state.shopProfile.activeModal;
export const shopProfileProfessionalSelector = (state: StyleteqState) => state.shopProfile.professionals;
export const shopBoothsSelector = (state: StyleteqState) => state.shopProfile.booths










// WEBPACK FOOTER //
// ./app/client/shop/selectors.ts